import React from 'react';
import { ReactComponent as GatewayLogo } from '../svg/gateway-logo.svg';
import { Link } from 'react-router-dom';

const AuthLayout = ({ children }) => {
    return (
        <div className="auth-layout container">
            <div className="col-12 col-md-6 mx-auto mt-md-32 txt-left rounded-md bg-light p-4 border-md border-1">
                <div className="mb-4 txt-center">
                    <Link to="/">
                        <GatewayLogo width={300} className="audioengine-logo" />
                    </Link>
                </div>
                {children}
                <div className="signin-footer txt-center mt-5">
                    <small>&copy; {new Date().getFullYear()} Findaway. All rights reserved.</small>
                </div>
            </div>
        </div>
    );
};

export default AuthLayout;
